import React from 'react';
import Avatar from "../commonComponents/Avatar";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { useDispatch } from "react-redux";
import authSlice from "../../store/auth/authSlice";

function ProfileConnection(props) {
    const dispatch = useDispatch();
    const openProfile = (userId, offeringUserId) => {
        dispatch(
            authSlice.actions.setProfileData({
                userId: userId,
                offeringUserId: offeringUserId,
            })
        );
        dispatch(
            authSlice.actions.setProfileStack({
                userId: userId,
                offeringUserId: offeringUserId,
            })
        );
        dispatch(authSlice.actions.setProfileLoader({ showLoader: true }));
        dispatch(authSlice.actions.showProfile());
        setTimeout(function () {
            dispatch(authSlice.actions.setProfileLoader({ showLoader: false }));
        }, 2000);
    };
    const popover = (
        <Popover id="popover-basic" className="profilePopover profileConnectionPopover">
            <div className="popover-profile-top-section">
                <Avatar {...props} className="small" />
                <div className="profile-details">
                    <div className="profile-name">
                        {props.firstName + " " + props.lastName}
                    </div>
                    <div className="profile-teamname">{props.teamName}</div>
                    <div className="profile-missionname">{props.missionName}</div>
                </div>
            </div>
            <div className="popover-profile-bottom-section">
                <div className="profile-email">{props.email}</div>
                <div
                    className="profile-view"
                    onClick={() => {
                        openProfile(props.userId, props.offeringUserId);
                    }}
                >
                    View Profile
                </div>
            </div>
        </Popover>
    );
    return (
        <div>
            <div className="connection-information">
                <Avatar {...props} className="small" />
                <OverlayTrigger
                    trigger="click"
                    placement="auto"
                    overlay={popover}
                    rootClose
                >
                    <div
                        className="connection-name"
                    >{props.firstName} {props.lastName}
                    </div>
                </OverlayTrigger>
            </div>
        </div>
    );
}

export default ProfileConnection;